export default __webpack_public_path__ + "static/media/InfillGeometryImg.3b53b5f9.jpg";